import { createContext } from "react";
const TableOrListingContext = createContext({});
export default TableOrListingContext;
